import Accordion from '@sly/frontend/react/shared/components/Accordion';
import { DynamicFaqProps } from 'sly/hubPage/components/HubDynamicContent/DynamicFaq/DynamicFaq.types';

export default function DynamicFaq({
  title,
  description,
  withMarginBottom,
  withMarginTop,
}: DynamicFaqProps) {
  const marginTop = withMarginTop ? 'mt-xs' : '';
  const marginBottom = withMarginBottom ? 'mb-xl' : '';
  const tabletMarginTop = withMarginTop ? 'mt-m' : 'mt-0';
  const tabletMarginBottom = withMarginBottom ? 'mb-xl' : 'mb-0';

  return (
    <div
      className={`${marginTop} ${marginBottom} w-[calc(100%-2rem)] md:w-[var(--col6)] ${tabletMarginTop} ${tabletMarginBottom} lg:w-[var(--col8)]`}
      data-tp-id='gen-div-8790c6d5-a354-4baf-bdfc-c7fc981a363a'
    >
      <hr className='m-0 border-0 border-t border-t-slate-lighter-90 md:mb-l' />
      <Accordion title={title} content={description} parseRaw />
      <div
        className={`mt-l ${!withMarginBottom && 'mb-l md:mb-xl'} md:mt-xl`}
        data-tp-id='gen-div-f23d1f50-3ea5-467e-8e32-ff6137bb716c'
      >
        {withMarginBottom && (
          <hr className='m-0 border-0 border-t border-t-slate-lighter-90 md:mb-l' />
        )}
      </div>
    </div>
  );
}
